import { useRef, useState } from "react";
import { loginWithApple, loginWithGoogle } from "../../../services/firebase";
import { LoginState } from "../types/login.types";

// useLoginAuth implemented as a function declaration
// `initialEmail`: the address the visitor already typed on the surface that
// sent them here (signup sheet / signup flow), so they don't retype it.
export function useLoginAuth(initialEmail: string | null) {
  const [state, setState] = useState<LoginState>({
    email: initialEmail === null ? "" : initialEmail,
    isOAuthLoading: false,
  });

  function setEmail(email: string) {
    setState((prev) => ({ ...prev, email }));
  }

  const isOAuthLoadingRef = useRef(false);

  async function handleOAuth(provider: "apple" | "google") {
    if (isOAuthLoadingRef.current) return;
    isOAuthLoadingRef.current = true;
    setState((prev) => ({ ...prev, isOAuthLoading: true }));
    try {
      switch (provider) {
        case "apple": {
          await loginWithApple({
            surface: "login_page",
            intent: "login",
            returnTo: null,
          });
          return;
        }
        case "google": {
          await loginWithGoogle({
            surface: "login_page",
            intent: "login",
            returnTo: null,
          });
          return;
        }
        default: {
          throw new Error(provider satisfies never);
        }
      }
    } finally {
      isOAuthLoadingRef.current = false;
      setState((prev) => ({ ...prev, isOAuthLoading: false }));
    }
  }

  return {
    // State
    ...state,

    // Actions
    setEmail,
    handleOAuth,
  };
}
